<!--
 * @Author: 程序员
 * @Description: 登录页
 * @Date: 2021-07-08 09:27:35
-->
<template>
  <div class="rbd-login">
    <header class="rbd-header flex-middle">
      <!-- <img
        src="../assets/images/common/login/logo_02.png"
        alt="四川交职院一网通办"
      /> -->
    </header>
    <main class="rbd-main flex-middle flex-center">
      <div class="rbd-main-wrap flex-row">
        <div class="rbd-main-explain">
          <div class="rbd-text-info">
            <div class="rbd-text-item">
              <div>
                <img src="../assets/images/common/login/01.png" alt="网上办" />
              </div>
              <div>
                <h3 style="color: #2073e8">网上办</h3>
                <p>一站式，</p>
                <p>智能化网上办事</p>
              </div>
            </div>
            <div class="rbd-text-item" style="margin-top: -10%">
              <div>
                <img src="../assets/images/common/login/02.png" alt="掌上办" />
              </div>
              <div>
                <h3 style="color: #f04949">掌上办</h3>
                <p>随时随地，</p>
                <p>提高办事效率</p>
              </div>
            </div>
            <div class="rbd-text-item" style="margin-top: -10%">
              <div>
                <img src="../assets/images/common/login/03.png" alt="不见面" />
              </div>
              <div>
                <h3 style="color: #48890e">不见面</h3>
                <p>打破壁垒，</p>
                <p>实现协同办公</p>
              </div>
            </div>
            <div class="rbd-text-item">
              <div>
                <img
                  src="../assets/images/common/login/04.png"
                  alt="一网通办"
                />
              </div>
              <div>
                <h3 style="color: #e87c07">一网通办</h3>
                <p>优化办事流程，</p>
                <p>构建流程服务体系</p>
              </div>
            </div>
          </div>
        </div>
        <div class="rbd-main-form flex-middle flex-center">
          <a-form-model
            ref="loginForm"
            :model="form"
            :rules="formRules"
            class="rbd-form-login"
            @submit="onSubmit"
          >
            <a-form-model-item>
              <a-radio-group v-model="form.is_admin" @change="onChangeRole">
                <a-radio-button class="rbd-switch-radio" :value="1">
                  管理员登录
                </a-radio-button>
                <span
                  class="rbd-active-line"
                  :style="`transform: translate3d(${
                    form.is_admin ? '100%' : '0%'
                  },0,0);`"
                ></span>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item prop="username">
              <a-input
                v-model="form.username"
                size="large"
                placeholder="用户名"
              >
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
            <a-form-model-item prop="password">
              <a-input
                v-model="form.password"
                size="large"
                type="password"
                placeholder="密码"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
            <a-form-model-item>
              <a-button
                type="default"
                size="large"
                html-type="submit"
                block
                class="rbd-btn-login"
                :loading="isLoading"
              >
                登录
              </a-button>
            </a-form-model-item>
            <div class="rbd-form-explain">
              <p style="text-indent: 2em">
                为了更好的体验效果，请在1920*1080分辨率下使用，推荐使用以下浏览器：
              </p>
              <p class="flex-row flex-middle">
                <i class="rbd-icon-gg"></i><span>谷歌</span>
                <i class="rbd-icon-hh"></i><span>火狐</span>
                <i class="rbd-icon-sll"></i><span>360（极速模式）</span>
              </p>
            </div>
          </a-form-model>
        </div>
      </div>
    </main>
    <footer class="rbd-footer"></footer>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import {
  apiGetPublicKey,
  apiGetCasConfig,
  apiAdminLogin,
  apiGetConfig,
} from "../services/commonApi";
import { __FUNC__ } from "../utils/func";
export default {
  data() {
    return {
      isLoading: false,
      cas_enable: false,
      form: {
        is_admin: 1, //管理员登录
        username: "",
        password: "",
      },
      formRules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        public_key: "",
      },
    };
  },
  created() {
    const that = this;
    that.mtt_removeUser();
    apiGetCasConfig().then((res) => {
      that.cas_enable = res.result.cas_enable;
      that.mtt_casInfo(res.result);
    });
    const public_key = window.localStorage.getItem("public_key");
    if (!public_key) {
      apiGetPublicKey().then((res) => {
        that.public_key = res.key;
        window.localStorage.setItem("public_key", res.key);
      });
    } else {
      that.public_key = public_key;
    }
  },
  methods: {
    ...mapMutations([
      "mtt_removeUser",
      "mtt_userInfo",
      "mtt_authMenu",
      "mtt_setToken",
      "mtt_logoConfig",
      "mtt_casInfo",
    ]),
    onChangeRole() {
      this.$refs.loginForm.resetFields();
    },
    onSubmit(e) {
      e.preventDefault();
      const that = this;
      that.$refs.loginForm.validate((valid) => {
        if (!valid) {
          return;
        }
        that.isLoading = true;
        let that_form = that.form;
        let is_admin = that_form.is_admin;
        let queryPath = that.$route.query && that.$route.query.redirect;
        let _pathName = "/cms";
        let rsaPassword = __FUNC__.rsaEncryptedData({
          public_key: that.public_key,
          password: that_form.password,
        });
        let promiseLogin = apiAdminLogin({
          ...that_form,
          password: rsaPassword,
        });
        promiseLogin
          .then((res) => {
            //存储用户菜单
            let authRoutes = [];
            const loopMenu = (data) => {
              data.forEach((menu) => {
                authRoutes.push(...menu.relationRoutes);
                if (menu.children?.length) {
                  loopMenu(menu.children);
                }
              });
            };
            loopMenu(res.menus.cms);
            //存储token
            that.mtt_setToken(res.Authorization);
            //存储用户信息
            that.mtt_userInfo({ ...res.user_info, is_admin });
            //存储用户菜单
            that.mtt_authMenu(authRoutes);
            //获取logo配置
            apiGetConfig().then((res_config) => {
              // this.mtt_logoConfig(res_config.data);
              window.localStorage.setItem(
                "__LOGO__CONFIG",
                JSON.stringify(res_config.data)
              );
              document.querySelector("#browserIcon").href =
                res_config.data.icon;
            });
            //记忆跳转
            if (res.error === "warning" || res.error === "error") {
              that.$message[res.error](res.message).then(() => {
                that.$router.push({ path: queryPath || _pathName });
              });
            } else {
              that.$router.push({ path: queryPath || _pathName });
            }
          })
          .finally(() => {
            setTimeout(() => {
              that.isLoading = false;
            }, 200);
          });
      });
    },
    getUrlParms(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    /*//匹配权限菜单
    getAuthMenus(authRouters = [], allRouters = []) {
      var realRoutes = [];
      allRouters.forEach((v, i) => {
        authRouters.forEach((w, j) => {
          if (w.name === v.name) {
            if (w.children && w.children.length > 0) {
              v.children = this.getAuthMenus(w.children, v.children);
            }
            realRoutes.push(v);
          }
        });
      });
      return realRoutes;
    },*/
  },
};
</script>

<style scoped>
.rbd-login {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background: url("../assets/images/common/login/login-bg.png") center center
    no-repeat;
  background-size: cover;
}
.rbd-header {
  width: 100vw;
  height: 9vh;
  padding: 0 30px;
}
.rbd-main {
  width: 100vw;
  height: 82vh;
  padding: 30px;
}
.rbd-main-wrap {
  display: flex;
  width: 72%;
  height: 92%;
  max-width: 1400px;
  max-height: 660px;
  background: #fff;
  border-radius: 6px;
}
.rbd-main-explain {
  width: 60.88%;
  height: 100%;
  border-right: 1px solid #e9e9e9;
  position: relative;
  background: url("../assets/images/common/login/login-box-left.png") 50% bottom
    no-repeat;
  background-size: contain;
}
.rbd-text-info {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  height: 30%;
  margin-top: 18%;
  position: relative;
}
.rbd-text-item {
  display: flex;
  flex-direction: row;
  min-width: 166px;
  margin-left: 3%;
}
.rbd-text-item div {
  display: inline-flex;
  flex-direction: column;
}
.rbd-text-item div:last-of-type {
  margin-left: 10px;
}
.rbd-text-item div h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 0;
}
.rbd-main-form {
  flex: 1;
  height: 100%;
}
.rbd-form-login {
  width: 66%;
}
.ant-form-item {
  margin-bottom: 30px;
}
.ant-form-item-with-help {
  margin-bottom: 11px;
}
::v-deep .ant-form-item-children,
::v-deep .ant-radio-group {
  display: flex;
  flex-direction: row;
  width: 100%;
}
::v-deep .ant-radio-group {
  border-bottom: 1px solid #dce1e7;
}
::v-deep .ant-radio-button-wrapper {
  flex: 1;
  height: 60px;
  line-height: 60px;
  text-align: center;
  padding: 0;
  font-size: 18px;
  border-color: transparent !important;
  box-shadow: none !important;
}
::v-deep .ant-radio-button-wrapper:not(:first-child)::before {
  content: none;
}
.rbd-switch-radio:hover,
.rbd-switch-radio.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  color: #1890ff;
}
.rbd-active-line {
  position: absolute;
  bottom: 0;
  z-index: 1;
  display: block;
  height: 3px;
  width: 100%;
  background: #1890ff;
  transition: all 0.3s;
  left: -100%;
}
.rbd-btn-login {
  background: linear-gradient(to right, #387edb, #68bafc);
  transition: none;
  color: #fff;
  font-size: 20px;
}
.ant-btn:hover,
.ant-btn:focus,
.ant-btn:active,
.ant-btn.active {
  color: #fff;
  background: #3888ff;
}
::v-deep .ant-input-lg,
::v-deep .ant-btn-lg {
  height: 50px;
}
.rbd-form-explain i {
  display: inline-block;
  width: 26px;
  height: 26px;
  background-size: contain;
}
.rbd-icon-gg {
  background: url("../assets/images/common/login/google.png") center center
    no-repeat;
}
.rbd-icon-hh {
  background: url("../assets/images/common/login/firefox.png") center center
    no-repeat;
}
.rbd-icon-sll {
  background: url("../assets/images/common/login/360.png") center center
    no-repeat;
}
.rbd-form-explain {
  padding-top: 20px;
}
.rbd-form-explain p {
  margin-bottom: 10px;
}
.rbd-form-explain span {
  margin-left: 3px;
  margin-right: 10px;
}
.rbd-footer {
  width: 100vw;
  height: 9vh;
  padding: 0 30px;
}
@media screen and (max-width: 1366px) {
  .rbd-text-info {
    margin-top: 16%;
  }
  .rbd-text-item {
    margin-left: 0;
    min-width: 136px;
  }
  .rbd-text-item div h3 {
    font-size: 14px;
  }
  .rbd-text-item div p {
    font-size: 12px;
  }
  .rbd-form-login {
    width: 80%;
  }
  .ant-form-item {
    margin-bottom: 22px;
  }
  .ant-form-item-with-help {
    margin-bottom: 3px;
  }
  ::v-deep .ant-input-lg,
  ::v-deep .ant-btn-lg {
    height: 36px;
  }
  .rbd-form-explain {
    padding-top: 0px;
  }
}
</style>
